import React, { useEffect, useMemo, useState } from "react";
import { Grid, Collapse, Divider } from "@mui/material";
import CatalogueHookProduct from "./CatalogueHookProduct";
import { ReactComponent as DownArrow } from "assets/icons/catalogViewIcons/DownArrow.svg";
import { ReactComponent as CollapseAll } from "assets/icons/catalogViewIcons/CollapseAll.svg";

const CategoryView = ({
    allData,
    innerChnages,
    isEdit,
    checkedItems,
    handleCheckboxChange,
    cartData,
}) => {
    const [collapsed, setCollapsed] = useState({});
    const [allCollapsed, setAllCollapsed] = useState(false);

    const groupedData = useMemo(() => {
        const map = new Map();
        allData.forEach((item) => {
            const category = item.categoryName || "Others";
            if (!map.has(category)) map.set(category, []);
            map.get(category).push(item);
        });
        return [...map];
    }, [allData]);

    const totalCount = allData.length;
    const categoryCount = groupedData.length;

    const toggleCategory = (category) => {
        setCollapsed((prev) => ({
            ...prev,
            [category]: !prev[category],
        }));
    };

    const toggleAll = () => {
        const next = !allCollapsed;
        setAllCollapsed(next);
        const newState = {};
        groupedData.forEach(([category]) => {
            newState[category] = next;
        });
        setCollapsed(newState);
    };

    useEffect(() => {
        if (groupedData.length === 0) {
            if (allCollapsed) setAllCollapsed(false);
            return;
        }

        const everyCategoryCollapsed = groupedData.every(
            ([category]) => Boolean(collapsed[category])
        );
        if (allCollapsed !== everyCategoryCollapsed) {
            setAllCollapsed(everyCategoryCollapsed);
        }
    }, [groupedData, collapsed, allCollapsed]);

    return (
        <div style={{ width: "100%" }}>
            <div style={{
                fontFamily: "Poppins",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: ".9vw",
                color: "white",
                fontWeight: "700",
                height: "3.5vw",
                width: "100%",
                padding: "0 .5vw",
                boxSizing: "border-box",
            }}>
                <span style={{ fontWeight: 400, fontSize: "24px", }}>Category - {categoryCount}({totalCount})</span>
                <span
                    onClick={toggleAll}
                    style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                    role="button"
                    tabIndex={0}
                    onKeyPress={(e) => e.key === "Enter" && toggleAll()}
                    aria-label={allCollapsed ? "Expand all" : "Collapse all"}
                >
                    <CollapseAll
                        style={{
                            transform: allCollapsed ? "rotate(-90deg)" : "rotate(0deg)",
                            transition: "transform 0.3s ease",
                        }}
                    />
                </span>
            </div>

            {/* CATEGORY SECTIONS */}
            {
                groupedData.map(([category, items]) => {
                    const isCollapsed = collapsed[category];

                    return (
                        <div key={category} style={{ width: "100%" }}>
                            <div style={{
                                fontFamily: "Karla",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                fontSize: ".9vw",
                                color: "white",
                                fontWeight: "500",
                                fontSize: "18px",
                                height: "3vw",
                                width: "100%",
                                padding: "0 .5vw",
                                boxSizing: "border-box",
                                cursor: "pointer",
                            }}
                                onClick={() => toggleCategory(category)}
                                role="button"
                                tabIndex={0}
                                onKeyPress={(e) => e.key === "Enter" && toggleCategory(category)}
                                aria-expanded={!isCollapsed}
                            >
                                <span>{category} - {items.length}</span>
                                <DownArrow
                                    style={{
                                        transform: isCollapsed ? "rotate(-90deg)" : "rotate(0deg)",
                                        transition: "transform 0.3s ease",
                                        flexShrink: 0,
                                    }}
                                />
                            </div>

                            {/* PRODUCTS */}
                            <Collapse in={!isCollapsed} timeout={300} unmountOnExit={false}>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    sx={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        gap: "1.8vw",
                                        rowGap: "1.8vw",
                                        padding: "10px 0 20px 0",
                                        width: "100%",
                                    }}
                                >
                                    {items.map((design, index) => (
                                        <Grid item key={`${design?.id}-${index}`} className="product">
                                            <CatalogueHookProduct
                                                design={design}
                                                index={`${index}-${design?.id}`}
                                                innerChnages={innerChnages}
                                                isEdit={isEdit}
                                                checkedItems={checkedItems}
                                                handleCheckboxChange={handleCheckboxChange}
                                                cartData={cartData}
                                                allData={allData}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Collapse>

                            {/* <Divider sx={{ opacity: 1, borderWidth: "1px", borderColor:"#444444" }} /> */}
                            <hr style={{ opacity: 1, borderWidth: "1px",borderColor:"#444444" }} />
                        </div>
                    );
                })
            }
        </div >
    );
};

export default CategoryView;